<div class="spacer">
  <button
    (click)="set(true)"
    [ngClass]="{
      hidden:
        (!isDisplay && !show && !budgetHierarchy) ||
        hierarchyItem?.parent?.masterKeyTypeId === keyNodeType.CrossKeyChild ||
        (budgetHierarchy && hierarchyItem?.masterKeyTypeId === keyNodeType.ControlKey)
    }"
    mat-icon-button
    class="actions-button"
    [matMenuTriggerFor]="actions"
  >
    <mat-icon>more_vert</mat-icon>
  </button>
  <!-- <div *ngIf="crossKeyHierarchy && !ownOperatingKey && !hierarchyItem.isChangeKey" class="master">
    <span *ngIf="hierarchyItem.isMasterOperator" class="asterisk">*</span>
    <span *ngIf="hierarchyItem.directChangesOperate">#</span>
    <button mat-icon-button [matMenuTriggerFor]="operatorActions" [disabled]="hierarchyItem.disabledCheckBox">
      <mat-icon>more_horiz</mat-icon>
    </button>
  </div> -->
</div>

<mat-menu #actions (closed)="set(false)">
  <button
    mat-menu-item
    *ngIf="!hierarchyItem?.parent && !keySystem?.isDummyTopMaster"
    (click)="
      patchItem({
        masterKey: hierarchyItem,
        type: 'dummyTmk',
        isDummy: true
      })
    "
  >
    <mat-icon>add</mat-icon>Convert to Dummy TMK
  </button>

  <button
    mat-menu-item
    *ngIf="!hierarchyItem?.parent && keySystem?.isDummyTopMaster"
    (click)="
      patchItem({
        masterKey: hierarchyItem,
        type: 'dummyTmk',
        isDummy: false
      })
    "
  >
    <mat-icon>add</mat-icon>Convert to Active TMK
  </button>

  <button
    mat-menu-item
    *ngIf="hierarchyItem?.masterKeyTypeId === keyNodeType.Master"
    (click)="
      addChild({
        masterKey: hierarchyItem,
        action: 'DIRECT_CHANGES_NODE'
      })
    "
  >
    <mat-icon>add</mat-icon>Add Direct Changes Node
  </button>

  <button
    mat-menu-item
    *ngIf="
      (hierarchyItem?.masterKeyTypeId === keyNodeType.Master &&
        !isResidentialSystem) ||
      (isResidentialSystem && hierarchyItem.levelsOfKeying > 3) ||
      !hierarchyItem.parentId
    "
    (click)="
      addChild({
        masterKey: hierarchyItem,
        action: 'MASTER_KEYS'
      })
    "
  >
    <mat-icon>add</mat-icon>Add Master
  </button>

  <button
    mat-menu-item
    *ngIf="
      !budgetHierarchy &&
      (hierarchyItem?.masterKeyTypeId === keyNodeType.DirectChangeMaster ||
        hierarchyItem?.masterKeyTypeId === keyNodeType.SingleKeyDifferentMaster ||
        (hierarchyItem?.masterKeyTypeId === keyNodeType.Master &&
          (!hasSubMasters(hierarchyItem) || hasChangeKeys(hierarchyItem))))
    "
    (click)="
      addChild({
        masterKey: hierarchyItem,
        action: 'CHANGE_KEYS'
      })
    "
  >
    <mat-icon>add</mat-icon>Add Change Keys
  </button>

  <button
    mat-menu-item
   *ngIf="moveKeysEnabled"
    (click)="
      addChild({
        masterKey: hierarchyItem,
        action: 'MOVE_KEYS'
      })
    "
  >
    <mat-icon>add</mat-icon>Move Key(s)
  </button>

  <button
    mat-menu-item
   *ngIf="renameKeysEnabled && !(budgetHierarchy && hierarchyItem?.masterKeyTypeId === keyNodeType.ControlKey)"
    (click)="
      addChild({
        masterKey: hierarchyItem,
        action: 'RENAME_KEYS'
      })
    "
  >
    <mat-icon>add</mat-icon>Rename Key(s)
  </button>

  <button
    mat-menu-item
   *ngIf="changeKeyTypeEnabled && !(budgetHierarchy && hierarchyItem?.masterKeyTypeId === keyNodeType.ControlKey)"
    (click)="
      addChild({
        masterKey: hierarchyItem,
        action: 'CHANGE_KEY_TYPE'
      })
    "
  >
    <mat-icon>add</mat-icon>Update Key(s) Type
  </button>

  <button
    mat-menu-item
    *ngIf="hierarchyItem?.masterKeyTypeId === keyNodeType.Master && !budgetHierarchy"
    (click)="
      addChild({
        masterKey: hierarchyItem,
        action: 'SLM'
      })
    "
  >
    <mat-icon>add</mat-icon>Add Selective Master
  </button>

  <button
    mat-menu-item
    *ngIf="hierarchyItem?.masterKeyTypeId === keyNodeType.ControlKeyMaster"
    (click)="
      addChild({
        masterKey: hierarchyItem,
        action: 'CONTROL_KEYS'
      })
    "
  >
    <mat-icon>add</mat-icon>Add Control Key
  </button>

  <button
    mat-menu-item
    *ngIf="hierarchyItem?.masterKeyTypeId === keyNodeType.Master"
    (click)="
      addChild({
        masterKey: hierarchyItem,
        action: 'SKD'
      })
    "
  >
    <mat-icon>add</mat-icon>Add SKD
  </button>

  <button
    mat-menu-item
    *ngIf="hierarchyItem?.masterKeyTypeId === keyNodeType.CrossKeyMaster"
    (click)="
      addChild({
        masterKey: hierarchyItem,
        action: 'cross'
      })
    "
  >
    <mat-icon>add</mat-icon>Add Cylinder
  </button>

  <button
    mat-menu-item
    *ngIf="hierarchyItem?.masterKeyTypeId === keyNodeType.CrossKeyMaster"
    (click)="
      addChild({
        masterKey: hierarchyItem,
        action: 'CROSS_KEY_RANGE'
      })
    "
  >
    <mat-icon>add</mat-icon>Add Cylinders
  </button>

  <button
    mat-menu-item
    *ngIf="hasChangeKeys(hierarchyItem) && !isCrossKey(hierarchyItem)"
    class="delete"
    (click)="
      deleteThruNotation({
        masterKey: hierarchyItem,
        action: 'DELETE_KEYS'
      })
    "
  >
    <mat-icon>delete_outline</mat-icon>
    Delete Change Keys
  </button>

  <button
    mat-menu-item
    *ngIf="(!hierarchyItem?.children || !hierarchyItem.children.length) && !(budgetHierarchy && hierarchyItem?.masterKeyTypeId === keyNodeType.ControlKey)"
    class="delete"
    (click)="deleteItem(hierarchyItem)"
  >
    <mat-icon>delete_outline</mat-icon>
    Delete
  </button>
</mat-menu>
